import { FolderSimple, DotsThreeVertical, Trash } from "@phosphor-icons/react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function FoldersGrid({ folders, clients, onSelectFolder, onDeleteFolder }) {
  if (!folders.length) return null;
  return (
    <div className="mb-6">
      <p className="label-overline mb-3">CARTELLE</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {folders.map((folder) => {
          const count = clients.filter((c) => c.folder_id === folder.id).length;
          return (
            <div
              key={folder.id}
              onClick={() => onSelectFolder(folder.id)}
              className="bg-[#171717] border border-[#262626] rounded-lg p-4 cursor-pointer hover:border-[#007AFF]/30 transition-colors group"
              data-testid={`folder-card-${folder.id}`}
            >
              <div className="flex items-start justify-between">
                <FolderSimple size={24} weight="duotone" className="text-[#D4FF00]" />
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button
                      className="text-zinc-600 hover:text-zinc-300 opacity-0 group-hover:opacity-100 transition-opacity"
                      onClick={(e) => e.stopPropagation()}
                      data-testid={`folder-menu-${folder.id}`}
                    >
                      <DotsThreeVertical size={18} />
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="bg-[#171717] border-[#262626]">
                    <DropdownMenuItem
                      className="text-red-400 hover:text-red-300 focus:bg-red-500/10 cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteFolder(folder.id);
                      }}
                    >
                      <Trash size={16} className="mr-2" /> Elimina
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
              <p className="text-sm font-medium text-white mt-2 truncate">{folder.name}</p>
              <p className="text-xs text-zinc-500 mt-1">{count} clienti</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
